module.exports = __webpack_public_path__ + "img/10-half-lg.28d27d24.jpg";